module.exports = __webpack_public_path__ + "static/img/overlay-work3.7eda4ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/overlay-work3.png
// module id = 178
// module chunks = 0